// This file is generated by pnpm icons:generate. Do not edit.

import {Group3_Stroke2_Corner0_Rounded as CanonicalGroup3_Stroke2_Corner0_Rounded} from './Group3'

/** @deprecated Import Group3_Stroke2_Corner0_Rounded from `#/components/icons/Group3` instead. */
export const Group3_Stroke2_Corner0_Rounded =
  CanonicalGroup3_Stroke2_Corner0_Rounded
